// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KEk6","left":"styles_left__jCI3B","desktopActions":"styles_desktopActions__2fWRt","title":"styles_title__1SUDO"};